var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrientation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6906 22.3708L34.8646 15.1438L31.9386 15.2378C31.5416 6.75576 24.5476 -0.000244141 15.9786 -0.000244141C7.15361 -0.000244141 0.000610352 7.16376 0.000610352 15.9998C0.000610352 24.8368 7.15361 31.9998 15.9786 31.9998C20.2866 31.9998 24.1966 30.2928 27.0706 27.5168C27.4646 27.1368 27.5126 26.5218 27.1596 26.1028L26.9756 25.8848C26.6146 25.4568 25.9606 25.4068 25.5606 25.7988C23.0906 28.2218 19.7086 29.7148 15.9786 29.7148C8.41461 29.7148 2.28261 23.5738 2.28261 15.9998C2.28261 8.42576 8.41461 2.28576 15.9786 2.28576C23.2866 2.28576 29.2586 8.01776 29.6526 15.2378L26.5176 15.1438L30.6906 22.3708Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5533 14.3777C18.5533 14.8557 18.1663 15.2417 17.6893 15.2417H14.2313C13.7543 15.2417 13.3673 14.8557 13.3673 14.3777V12.1867C13.3673 10.9287 14.5313 9.90466 15.9603 9.90466C17.3893 9.90466 18.5533 10.9317 18.5533 12.1867V14.3777ZM15.9603 8.38062C13.5783 8.38062 11.6383 10.0846 11.6383 12.1866V14.3736C11.6383 14.8516 11.2513 15.2376 10.7743 15.2376C10.2973 15.2376 9.9093 15.6246 9.9093 16.1026V21.9926C9.9093 22.4706 10.2973 22.8566 10.7743 22.8566H21.1463C21.6233 22.8566 22.0113 22.4706 22.0113 21.9926V16.1026C22.0113 15.6246 21.6233 15.2376 21.1463 15.2376C20.6693 15.2376 20.2823 14.8516 20.2823 14.3736V12.1866C20.2823 10.0916 18.3473 8.38062 15.9603 8.38062Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrientation);
export default __webpack_public_path__ + "static/media/orientation.40a14279.svg";
export { ForwardRef as ReactComponent };